// extracted by mini-css-extract-plugin
export default {"nav_mainContainer":"nav_nav_mainContainer__uOmoq","nav_logo":"nav_nav_logo__B3y3g","nav_items":"nav_nav_items__+v3lE"};